import { Tabs } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { strings } from "../../../helpers";
import PharmacyBasicInfoContainer from "../BasicInfo/PharmacyBasicInfoContainer";
import MetricsPharmacyContainer from "../Metrics/PharmacyMetricsContainer";
import PharmacyClinicListContainer from "../Clinics/PharmacyClinicListContainer";

const { TabPane } = Tabs;

export default class PharmacyDetailTabView extends React.Component {
  render() {
    const { currentPath, details, pharmacyId } = this.props;

    const basicInfo = `/pharmacy-details/${pharmacyId}/basic-details`;
    const metrics = `/pharmacy-details/${pharmacyId}/metrics`;
    const clinics = `/pharmacy-details/${pharmacyId}/clinics`;

    return (
      <div className="kc-tabs-view appointment-content-container">
        <Tabs
          type="card"
          className="px-10 line-tabs"
          activeKey={
            currentPath === "basic-details" ? "basic-details" : currentPath
          }
        >
          <TabPane
            key="basic-details"
            tab={<Link to={basicInfo}>{strings.dashboard.details}</Link>}
          >
            <PharmacyBasicInfoContainer details={details} />
          </TabPane>
          <TabPane
            key="metrics"
            tab={<Link to={metrics}>{strings.dashboard.metrics}</Link>}
          >
            <MetricsPharmacyContainer details={details} />
          </TabPane>

          <TabPane
            key="clinics"
            tab={<Link to={clinics}>{strings.dashboard.clinic}</Link>}
          >
            <PharmacyClinicListContainer details={details} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
